<template>
  <div class="post-item">
    <div class="post-image">
      <input
        type="radio"
        name="post-item-shared"
        :id="'post_shared_' + post.id"
        class="hidden"
      />
      <a :href="'/'+ this.locale + post.path" class="block w-full" @click="trackSelectItem">
        <div class="image-block aspect-square no-mask no-shadow pointer-events-none">
          <img v-if="isFirstScreen"
               :src="post.cover_image_src"
               :alt="post.title"
               class="image"
               loading="eager" />
          <img v-else
               v-lazy="post.cover_image_src"
               :alt="post.title"
               class="image" />
        </div>
      </a>
      <div
        v-if="parseFloat(post.price) === 0"
        class="free-tag w-10 h-4 text-center font-medium absolute top-2 left-2 bg-red text-xs"
      >
        {{ $t('post_item.free') }}
      </div>
      <div
        v-if="post.phrozen_verified"
        class="flex items-center justify-center pv-tag w-10 h-4 text-center font-medium absolute top-2 left-2 bg-red text-xs"
      >
      <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-0.5">
        <path d="M5.99941 9.57694C8.22979 9.57694 10.0379 7.76885 10.0379 5.53847C10.0379 3.30808 8.22979 1.5 5.99941 1.5C3.76902 1.5 1.96094 3.30808 1.96094 5.53847C1.96094 7.76885 3.76902 9.57694 5.99941 9.57694Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.9982 7.15363C6.89035 7.15363 7.61359 6.43039 7.61359 5.53824C7.61359 4.64609 6.89035 3.92285 5.9982 3.92285C5.10605 3.92285 4.38281 4.64609 4.38281 5.53824C4.38281 6.43039 5.10605 7.15363 5.9982 7.15363Z" fill="white"/>
        <path d="M8.15536 11.9996L6.00119 9.8457L3.84766 11.9996" stroke="white" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
      </svg>

        PV
      </div>

      <div class="post-data-container">
        <div v-if="parseFloat(post.price) > 0"
             class="flex ml-2 h-full">
          <span class="post-price">
            <Currency :price="post.price" :class="'h-full leading-[24px]'"/>
          </span>
          <span
            v-if="parseFloat(post.price) < parseFloat(post.original_price)"
            class="post-original-price"
          >
            <Currency :price="post.original_price" :class="'h-full leading-[24px]'"/>
          </span>
        </div>

        <div v-else
             class="ml-2 flex items-center h-full">
          <div v-if="parseFloat(post.views_count) >= 5"
               class="post-view-count flex items-center pr-2 h-full">
            <div class="icon mr-1 w-4 h-4"></div>
            {{ formatNumber(post.views_count) }}
          </div>
          <div v-if="parseFloat(post.likes_count) >= 5"
               class="post-likes-count hidden sm:flex items-center pr-2 h-full ">
            <div class="icon mr-1 w-4 h-4"></div>
            {{ formatNumber(post.likes_count) }}
          </div>
          <div v-if="parseFloat(post.downloads_count) >= 5"
               class="post-downloads-count flex items-center pr-2 h-full">
            <div class="icon mr-1 w-4 h-4"></div>
            {{ formatNumber(post.downloads_count) }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="!hidden_creator" class="post-info p-2 py-3">
      <div class="post-title truncate" :title="post.title">
        <a :href="'/'+ this.locale + post.path" class="hover:underline">{{ post.title }}</a>
      </div>
      <a :href="'/'+ this.locale + post.creator.public_path" class="creator-info">
        <div class="w-full flex items-center">
          <div class="flex-shrink-0">
            <img
              v-if="isFirstScreen"
              :src="post.creator.avatar_url"
              :alt="post.creator.brand_name"
              class="w-6 h-6 rounded-full"
              loading="eager" />
            <img
              v-else
              v-lazy="post.creator.avatar_url"
              :alt="post.creator.brand_name"
              class="w-6 h-6 rounded-full" />
          </div>
          <div class="pl-2 flex-1 truncate">
            <span class="text-12px display-name">
              {{ post.creator.brand_name }}
            </span>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
  import { defineComponent } from "vue";
  import { setupSharedLinks } from '../utils/postItemSharedLinks';
  import { getUrlLocale } from '../utils/getUrlLocale';
  import { isFirstScreenPost } from '../utils/firstScreenCalculator';
  import { clickedPostAfterSearch } from '../utils/algoliaInsights';
  import Currency from '../components/Currency.vue';

  export default defineComponent({
    props: ['post', 'hidden_creator', 'itemIndex', 'listName'],
    data() {
      return {
        locale: ''
      }
    },
    mounted() {
      this.locale = getUrlLocale();
    },
    methods: {
      labelClick(e) {
        let btn = document.getElementById(e.target.dataset.for)

        if (btn.checked) {
          btn.checked = false
        } else {
          btn.checked = true
          setupSharedLinks(e.target)
        }
      },
      trackSelectItem() {
        if (window.trackingEvent) {
          const raw = this.listName || 'unknown';
          const listId = typeof raw === 'object' ? raw.id : raw;
          const listName = typeof raw === 'object' ? raw.name : raw;
          window.trackingEvent.select_item({
            item_list_id: listId,
            item_list_name: listName,
            item_id: this.post.id,
            item_name: this.post.title,
            item_brand: this.post.creator?.brand_name,
            price: this.post.price,
            index: this.itemIndex,
          })
        }

        // Algolia Insights：來自搜尋結果（帶 __queryID）的點擊才送
        if (this.post?.__queryID) {
          clickedPostAfterSearch({
            queryID: this.post.__queryID,
            objectID: this.post.id,
            position: (this.itemIndex ?? 0) + 1,
          });
        }
      },
      formatNumber(value) {
        if (!value) return '0';
        value = Number(value);
        if (value < 1000) return value.toString();
        const result = (value / 1000).toFixed(1);
        return result + 'k';
      }
    },
    computed: {
      isFirstScreen() {
        // 如果沒有提供 itemIndex，預設為非首屏
        if (this.itemIndex === undefined || this.itemIndex === null) {
          return false;
        }
        return isFirstScreenPost(this.itemIndex);
      }
    },
    components: {
      Currency
    }
  })
</script>
